
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BaseWordLoading',
  props: {
    text: {
      type: String,
      default: 'Loading',
    },
  },
});
